import '~/js/modules/section-hero';
import 'slick-carousel';
import '~/js/modules/subscribe-form-dark';

// Sliders
const slider = $('.js-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<button aria-label="Previous" class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></button>',
  nextArrow: '<button aria-label="Next" class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></button>'
});

slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});

const $btnReadMore = $('.js-read-more');

$btnReadMore.on('click', function toggleText() {
  $(this).parent().next().toggleClass('hidden-xs');
});
